import { createOauthFunctionClient } from "./oauthFunctionClient";

// Client for the amazon-oauth Edge Function (DEV-2216). Shares
// createOauthFunctionClient with shopifyService.js: every call carries the
// user's JWT, and a failure throws an Error with the function's own message
// and the HTTP status it answered with (err.status).
const { invoke, requestUrl } = createOauthFunctionClient("amazon-oauth");

async function navigateTo(action, advertiserId, authToken, extra) {
  const url = await requestUrl(action, advertiserId, authToken, extra, "Amazon did not return an authorization URL");
  window.location.assign(url);
}

/**
 * Starts connecting an Amazon seller account: asks amazon-oauth for the
 * consent URL on the chosen region's Seller Central ("na" | "eu" | "fe"; the
 * function defaults to "na" when none is sent) and navigates there. After
 * consent, Amazon loads the console root (our Login URI) with
 * amazon_callback_uri, amazon_state, selling_partner_id and version, which
 * AuthGate captures.
 */
export async function startAmazonConnect(advertiserId, authToken, region) {
  const extra = { return_url: window.location.origin };
  if (region) extra.region = region;
  await navigateTo("start", advertiserId, authToken, extra);
}

/**
 * The Login URI step, called only from the explicit "Connect Amazon seller
 * account to ...?" prompt: sends the captured Amazon params to amazon-oauth,
 * which validates them and returns the Seller Central callback URL to
 * navigate to. `login` is the entry AuthGate persisted
 * ({ amazonCallbackUri, amazonState, sellingPartnerId, version }).
 */
export async function authorizeAmazonConnect(advertiserId, authToken, login) {
  const extra = {
    amazon_callback_uri: login.amazonCallbackUri,
    amazon_state: login.amazonState,
    selling_partner_id: login.sellingPartnerId,
    return_url: window.location.origin,
  };
  if (login.version) extra.version = login.version;
  await navigateTo("authorize", advertiserId, authToken, extra);
}

/**
 * Confirms a staged Amazon connection with the `confirm` token from the
 * callback's ?integration=amazon&status=pending redirect.
 */
export async function confirmAmazonConnect(advertiserId, confirmToken, authToken) {
  return invoke("confirm", advertiserId, authToken, { confirm_token: confirmToken });
}
